import styled from 'styled-components';
export const ReviewInput = styled.input`
  height: 0;
  width: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
`;